/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import DynamicAd from '@fe-news/components/DynamicAd/DynamicAd';
import DesktopAdProfiles from '@fe-news/constants/DFP/DesktopAdProfiles';
import MobileAdProfiles from '@fe-news/constants/DFP/MobileAdProfiles';
import { styled } from '@linaria/react';

type KeywordAdBannerProps = {
  desktopProfile: AD.Profile;
  mobileProfile: AD.Profile;
};

const AdContainer = styled.div`
  padding: 16px;
  min-height: 200px;
`;

const KeywordAdBanner = ({ desktopProfile, mobileProfile }: KeywordAdBannerProps) => {
  // 如果該篇新聞有設定主動關鍵式廣告，則取得廣告設定，否則為預設共用的 `NewsDetailArticleBottom` 廣告
  const adBannerOfArticleBottomInDesktop = desktopProfile ?? DesktopAdProfiles.NewsDetailArticleBottom;
  const adBannerOfArticleBottomInMobile = mobileProfile ?? MobileAdProfiles.NewsDetailArticleBottom;

  // AD (新聞文未主動式關鍵字 - 橫幅廣告)
  // 如果有設定主動關鍵式廣告，則顯示主動式關鍵字廣告，否則顯示預設的文未廣告
  return (
    <AdContainer>
      <DynamicAd
        desktopAdProfile={adBannerOfArticleBottomInDesktop}
        mobileAdProfile={adBannerOfArticleBottomInMobile}
      />
    </AdContainer>
  );
};

export default KeywordAdBanner;
